import { render, staticRenderFns } from "./registroGrupoModal.vue?vue&type=template&id=791eaab3&"
import script from "./registroGrupoModal.vue?vue&type=script&lang=js&"
export * from "./registroGrupoModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports